import { Box } from '@/components/ui/box'
import { HStack } from '@/components/ui/hstack'
import { Icon } from '@/components/ui/icon'
import { Image } from '@/components/ui/image'
import { Pressable } from '@/components/ui/pressable'
import { Text } from '@/components/ui/text'
import { VStack } from '@/components/ui/vstack'
import { formatLargeNumber } from '@/lib/utils/numberFormatter'
import type { Template } from '@/typings/template'
import { CopyIcon, ThumbsUpIcon } from 'lucide-react-native'

type TemplateCardProps = {
  template: Template
  onPress: (template: Template) => void
}

export default function TemplateCard({ template, onPress }: TemplateCardProps) {
  return (
    <Pressable onPress={() => onPress(template)}>
      <VStack space="md">
        <Box className="w-full aspect-square rounded-xl overflow-hidden border border-background-100">
          <Image
            source={{ uri: template.cover }}
            alt={template.templateName}
            className="w-full h-full"
            resizeMode="cover"
          />
        </Box>

        <VStack space="xs">
          <Text size="body" className="text-label" numberOfLines={1}>
            {template.templateName}
          </Text>

          <HStack space="md" className="items-center">
            <HStack space="xs" className="items-center">
              <Icon as={CopyIcon} size="sm" className="text-secondary-label" />
              <Text size="footnote" className="text-secondary-label">
                {formatLargeNumber(template.usedCount)}
              </Text>
            </HStack>

            <HStack space="xs" className="items-center">
              <Icon as={ThumbsUpIcon} size="sm" className="text-secondary-label" />
              <Text size="footnote" className="text-secondary-label">
                {formatLargeNumber(template.likes)}
              </Text>
            </HStack>
          </HStack>
        </VStack>
      </VStack>
    </Pressable>
  )
}
